import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlightPathBottom = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 739,
	height: 112,
	viewBox: "0 0 739 112",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M737.079 37.4634C680.707 10.0875 562.788 117.24 378.579 59.463C368.652 56.3494 358.642 53.574 348.579 51.1237M2.57866 88.0417C77.525 45.6881 195.596 24.4258 311.579 43.5863",
		stroke: "#176BEB",
		strokeDasharray: "10 10"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M336.038 36.4997L328.365 44.4908L321.958 43.2203C319.212 42.6758 316.652 43.595 315.922 44.8771C316.107 46.3408 318.123 48.1674 320.869 48.7119L327.276 49.9824L331.319 60.2966C331.576 60.9184 332.089 61.2104 332.674 61.1362L333.443 61.0983C334.138 60.9508 334.613 60.4743 334.649 59.8154L334.598 51.4344L339.356 51.4266L341.557 54.7169L343.388 55.0799L343.38 50.322L345.203 45.9272L343.372 45.5642L340.082 47.7655L335.687 45.9428L338.932 38.2151C339.15 37.5926 338.893 36.9708 338.307 36.5692L337.721 36.1676C337.098 35.949 336.513 36.0231 336.038 36.4997Z",
		stroke: "#176BEB",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgFlightPathBottom;
